import type { SponsoredPricingOptionAdvertStateBookingPanel } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/advertsBookingPanel';

export const get = (
  state: SponsoredPricingOptionAdvertStateBookingPanel,
): SponsoredPricingOptionAdvertStateBookingPanel['advert'] => state.advert;
